$.ajax(
  {
    url: '/api/admin/official/exc/banner?terminalType=2',
    type: 'GET',
    // beforeSend: function (res) {
    //   res.setRequestHeader('tenantId', 1001)
    // },
    dataType: 'json',
    success: function (res) {
      const list = res.data
      let contents = ''
      $.each(list, function (i) {
        if (list[i].typeOptionsId === 2) {
          url = `memberDetail.html?idx=0&id=${list[i].optionsId}&title=${list[i].optionsName}`
        } else if (list[i].typeOptionsId === 4) {
          url = `memberUnit.html?idx=0`
        } else {
          url = `bannerDetail.html?idx=0&id=${list[i].optionsId}&title=${list[i].optionsName}`
        }
        contents += `<li class="ft-carousel-item">
                      <a href=${url}>
                        <img src=${list[i].imgUrl} />
                      </a>
                    </li>`
        $(".banner-box").html(contents)
      })
    }
  }
)
